import React from 'react';

interface FooterColumnProps {
  heading: string;
  children: React.ReactNode;
}

function FooterColumn({ heading, children }: Readonly<FooterColumnProps>) {
  return (
    <section className="flex flex-col items-start p-4 md:w-1/2 lg:w-1/4">
      <h4 className="text-white font-normal text-2xl leading-8 mb-4">
        {heading}
      </h4>
      {children}
    </section>
  );
}

export default FooterColumn;
